export const ACTIONS = {
  PUSH_INSIGHTS_DATA: 'PUSH_INSIGHTS_DATA',
  UPDATE_INSIGHTS_DATA: 'UPDATE_INSIGHTS_DATA',
};

export const pushInsightsData = data => {
  return {
    type: ACTIONS.PUSH_INSIGHTS_DATA,
    payload: data,
  };
};

export const updateInsightsData = data => dispatch => {
  dispatch({
    type: ACTIONS.UPDATE_INSIGHTS_DATA,
    payload: data,
  });
};
